const scheduledServicesUsersList = {
  title: 'Responsáveis'
}

export default scheduledServicesUsersList;